import { Component } from 'react';
import { emptyField, ErrorMessage, errorsLength, formatErrors } from '../../../../../../../../insfrastructure/utils/form-validators';
import { Input } from '../../../../../../../components/input';
import './styles.sass'

export class AboutCompany extends Component<{form_data: Record<string, any>, onSubmit: (form: Record<string, any>) => void}> {

  state: any = {
    form: this.props.form_data,
    formErrors: {}
  }

  onSubmit = () => {
    const errors = formatErrors({
      description: [emptyField(this.state.form.description, 'string')],
      motivation: [emptyField(this.state.form.motivation, 'string')]
    });

    this.setState({ formErrors: errors });

    if(errorsLength(errors) > 0) return;

    try {
      setTimeout(() => {
        this.setState({ sended: true });
        this.props.onSubmit(this.state.form);
      });
    } catch (error) {
        this.setState({ loading: false });
    }
  }

  render() {
    return (
      <div className='form about-company'>
        <div className='form-container'>
          <div className='text'>
            <h4>Fale um pouco sobre a sua empresa.</h4>
            <p>As informações a serem compartilhadas aqui apareceram nos seus anúncios de vagas.</p>
          </div>
          <div className='columns'>
            <div className='column'>
              <Input
              name='description'
              label='Sobre a empresa:*'
              type='textarea'
              value={this.state.form.description}
              onChange={e => this.setState({ form: { ...this.state.form, description: e } })}/>
              <ErrorMessage errors={this.state.formErrors['description']} />
            </div>
            <div className='column'>
              <Input
              name='motivation'
              label='Por que trabalhar com a gente?*'
              type='textarea'
              value={this.state.form.motivation}
              onChange={e => this.setState({ form: { ...this.state.form, motivation: e } })}/>
              <ErrorMessage errors={this.state.formErrors['motivation']} />
            </div>
          </div>
          <button className='primary submit' onClick={this.onSubmit}>Confirmar</button>
        </div>
      </div>
    )
  }
}
